import { Form as AntdForm } from 'antd'

export const useFormInstance = AntdForm.useFormInstance
